import styled from 'styled-components';

const StyledDetailJob = styled.div`
  background-color: ${props => props.bgColor};
  padding-top: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-right: 64px;
  padding-left: 64px;
  .job--title-wrap,
  .job--description{
    position: relative;
    width: 66%;
  }
  .job--body-wrap,
  .job--intro{
    position: relative;
    width: 100%
  }
  .job--intro{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  .job--intro p {
    width: 66%;
  }
  .apply-wrap{
    display: flex;
    width: 33%;
    justify-content: center;
  }
  .job--description p{
    position: relative;
    margin-bottom: 24px;
    margin-left: 32px;
  }
  .job--description p:before{
    content: ""; 
    position: absolute;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #CDE4DC;
    left: -32px;
    top: 8px;
  }
  .job--intro .apply-wrap p {
    color: ${ props => props.theme.colors.green_secondary};
    margin-right: 16px;
    width: auto;
  }
  .job--title-wrap h4 {
    margin-bottom: 24px;
  }
  .job-location-wrap{
    position: relative;
    display: flex;
    align-items: center;
    justift-content: flex-start;
    color: #4D4D4D;
    margin-bottom: ${props => props.theme.components_spacing_desk.xlarge}px;
  }
  .job-location-wrap p {
    margin: 0 20px 0 8px;
  }
  .job-location-wrap .copy--clipboard {
    position: relative;
  }
  .job-location-wrap .copy--clipboard p {
    position: absolute;
    opacity: 0;
    margin: 0;
    z-index: 2;
    cursor: pointer;
    width: 100%;
    height: 100%;
  }
  .job-location-wrap .copy--clipboard .copied{
    content: 'Copied';
    position: absolute;
    top: 50%;
    transform: translate(100%, -50%);
    background-color: #4D4D4D;
    color: #fff;
    font-size: 14px;
    padding: 5px 10px;
    border-radius: 3px;
    opacity: 0;
  }
  .job--body-wrap h6 {
    margin: 40px 0;
  }
  .job--body-wrap p{
    color: #4D4D4D;
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px
  }
  @media screen and (max-width: 1023px){
    padding-top: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    .job-location-wrap{
      margin-bottom: ${props => props.theme.components_spacing_tablet.xlarge}px;
    }
    .job--description p{
      margin-left: 16px;
    }
    .job--description p:before{
      left: -16px;
    }
  }
  @media screen and (max-width: 767px){
    padding-right: 24px;
    padding-left: 24px;
    padding-top: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    .job--title-wrap,
    .job--body-wrap{
      width: 100%;
    }
    .job--description{
      width: 100%;
    }
    .job--intro {
      flex-direction: column;
    }
    .apply-wrap {
      width: auto;
      margin-top: 24px;
    }
    .job--intro p {
      width: 100%;
    }
    .job-location-wrap{
      margin-bottom: ${props => props.theme.components_spacing_mobile.xlarge}px;
    }
  }
`;

export {
  StyledDetailJob,
};

